var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserAdd = function SvgUserAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 12H4v-1a1 1 0 0 0-2 0v1H1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2m4-4a3 3 0 1 1 0-6 3 3 0 0 1 0 6m7 7a7 7 0 0 0-.033-.644q-.006-.073-.016-.145a7 7 0 0 0-.089-.589l-.007-.035a7 7 0 0 0-.166-.646l-.014-.043a7.04 7.04 0 0 0-3.435-4.097A4.99 4.99 0 0 0 14 5c0-2.757-2.243-5-5-5S4 2.243 4 5c0 1.524.688 2.889 1.766 3.807a7 7 0 0 0-.519.298l-.074.045a1 1 0 0 0 .576 1.815c.215 0 .411-.07.574-.184l.007-.004.016-.01q.278-.173.58-.312l.014-.007a5 5 0 0 1 1.305-.385l.058-.009q.342-.048.697-.05a5 5 0 0 1 5 5 1 1 0 0 0 2 0V15",
    clipRule: "evenodd"
  })));
};
export default SvgUserAdd;